import { AppShell } from "@mantine/core";
import { LAYOUT_APP_BAR_HEIGHT, LayoutAppBar } from "./LayoutAppBar";
import { LayoutDrawer } from "./LayoutDrawer";
import { useDisclosure } from "@mantine/hooks";
import { useAppUpdate } from "@jasper/use-cases";
import { APP_UPDATE_BANNER_HEIGHT, AppUpdateBanner } from "@jasper/shared";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useMatch } from "react-router-dom";

export const LoggedInLayout = ({ children }: { children: JSX.Element }) => {
  const isThemeV2Enabled = useFeatureFlagEnabled("theme_v2");
  const [opened, { toggle, close }] = useDisclosure(false);
  const { isUpdateAvailable, updateApp } = useAppUpdate();

  const match = useMatch("/orders/:orderId/configure/*");
  const isOnOrderFlow = !!match;

  const bannerHeight = isUpdateAvailable ? APP_UPDATE_BANNER_HEIGHT : 0;

  return (
    <AppShell
      layout="alt"
      header={
        isOnOrderFlow
          ? undefined
          : { height: LAYOUT_APP_BAR_HEIGHT + bannerHeight }
      }
      navbar={
        isOnOrderFlow
          ? undefined
          : {
              width: 225,
              breakpoint: "xs",
              collapsed: { mobile: !opened },
            }
      }
      padding={0}
      h="100vh"
    >
      {!isOnOrderFlow && (
        <AppShell.Header style={{ display: "flex", flexDirection: "column" }}>
          {isUpdateAvailable && <AppUpdateBanner onUpdate={updateApp} />}
          <LayoutAppBar navbarOpened={opened} toggleNavbar={toggle} />
        </AppShell.Header>
      )}
      {!isOnOrderFlow && <LayoutDrawer onLinkClick={close} onClose={close} />}
      <AppShell.Main
        h={isThemeV2Enabled ? undefined : "100%"}
        bg={isThemeV2Enabled ? "appBackground" : undefined}
      >
        {children}
      </AppShell.Main>
    </AppShell>
  );
};
